// src/Dashboard/pages/teacher/PrepaPhysique/components/PrepaPhysiqueTabs.jsx

import React from "react";
import { FaListUl, FaUserFriends } from "react-icons/fa";

const TABS = [
  {
    key: "exercices",
    label: "Exercices",
    description: "Bibliothèque",
    icon: FaListUl,
  },
  {
    key: "assignations",
    label: "Affectations",
    description: "Suivi adhérents",
    icon: FaUserFriends,
  },
];

export default function PrepaPhysiqueTabs({ activeTab, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const active = activeTab === tab.key;

        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`rounded-[24px] border px-4 py-4 text-left transition ${
              active
                ? "border-indigo-200 bg-indigo-50 shadow-sm ring-1 ring-indigo-200 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:ring-indigo-500/20"
                : "border-slate-200 bg-white hover:bg-slate-50 dark:border-slate-800 dark:bg-slate-900 dark:hover:bg-slate-800/70"
            }`}
          >
            <div className="flex items-center gap-3">
              <span
                className={`grid h-11 w-11 place-items-center rounded-2xl ${
                  active
                    ? "bg-[#013E8E] text-white"
                    : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300"
                }`}
              >
                <Icon />
              </span>

              <div>
                <p
                  className={`text-sm font-bold ${
                    active
                      ? "text-indigo-900 dark:text-indigo-100"
                      : "text-slate-900 dark:text-white"
                  }`}
                >
                  {tab.label}
                </p>

                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {tab.description}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}